// 不自动添加的路由，懒得加可以在页面内添加 {{ pass: true, }} 属性
const pass = []

const files = require.context("@/views", true, /\.vue$/);

const autoRoutes = []

files.keys().forEach(key => {
  let item = files(key);

  if (!item.default.pass && pass.indexOf(item) === -1) {
    let pathName = key.replace(/(\.\/|\.vue)/g, '');
    let fileName = pathName.replace(/.+\//g, ''); // filename
    pathName = "" + pathName.substring(0, pathName.lastIndexOf("/")); // path1/path2

    let name = pathName.replace(/\/(\w)/g, function (all, letter) {
      return letter.toUpperCase();
    }) + (fileName == "index" ? "" : fileName);
    // name = name.substring(0, 1).toUpperCase() + name.substring(1);

    let path = pathName === "home" ? "" : pathName;
    path += fileName === "index" ? "" : "/" + fileName;
    if (!path.startsWith('/')) {
      path = "/" + path;
    }
    if (item.default.urlName) {
      path += `/:${item.default.urlName}`
    }

    autoRoutes.push({
      path,
      name,
      component: item.default
    })
  }
})

export default autoRoutes;